export class GlobalViewDefinition {
    constructor({viewName, viewFriendlyName, viewDescription, viewRule, viewClientRule}) {
        this._viewName = viewName;
        this._viewFriendlyName = viewFriendlyName;
        this._viewDescription = viewDescription;
        this._viewRule = viewRule;
        this._viewClientRule = viewClientRule;
    }

    /* internal view name */
    get name() { return this._viewName; }
    /* Display name for the filter, presented to the user */
    get friendlyName() { return this._viewFriendlyName; }
    /* Description of the view, shown to the user */
    get description() { return this._viewDescription; }
    /* EventFilter transform function that implements the view.
     * Should be called whenever an eventFilter is processed into an actual datasource filter.
     */
    get rule() { return this._viewRule; }

    /* TrackingEvent client-side filter function
     * Takes a tracking event and returns true if it passes the view's filter, false otherwise.
     */
    get clientRule() { return this._viewClientRule; }

    viewInfo() {
        return {
            name: this.name,
            friendlyName: this.friendlyName,
            description: this.description
        };
    }
}

GlobalViewDefinition.WatchComparer = (newVal, oldVal) =>
    newVal != null && newVal["name"] != null && (oldVal == null || newVal["name"] !== oldVal["name"]);



//////////////////
// WEBPACK FOOTER
// ./src/models/GlobalView.js
// module id = dYMJ
// module chunks = 1